import React from 'react';
import ReactDOM from 'react-dom';

export const FormError = ({error}) => {
  return (
    <small className="form-text error">{error}</small>
  );
}
